export const PopEnum = {
  NEDESIFRIRANA_POVEZAVA_Z_AVTENTIKACIJO: '110',
  SIFRIRANA_POVEZAVA_PREK_SSL_ALI_TLS_PROTOKOLA: '995',
  SIFRIRANA_POVEZAVA_PREK_STARTLS_PROTOKOLA: '110'
}



// WEBPACK FOOTER //
// ./src/assets/js/Enum/ElektronskaPostaNastavitve/PopEnum.js